export function validateEmail (email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

export function validateScriptTags (script) {
  return /<script[^>]*>(.*?)<\/script[^>]*>/.test(script)
}

export function validateVideoUrl (url) {
  url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\S+)?/)
  return RegExp.$3.indexOf('youtu') > -1 || RegExp.$3.indexOf('vimeo') > -1 || url === ''
}
